import { AccountPermission } from "@syla/shared/types/models/AccountAccessBase";
import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import { hasAccountPermission } from "../../../helper/permissions";
import { useReportError } from "../../../helpers/useReportError";
import { AccountSubtypeSelector } from "../../../pages/accountSettings/AccountSubtypeSelector";
import { useMutationUpdateAccount } from "../../../store/useMutationUpdateAccount";
import { Account } from "../../../types/Account";
import { EditableFieldProps } from "../../molecules/EditableField";

export function AccountSubtypeTypeEditable({
  account,
  ...props
}: { account: Account } & Partial<EditableFieldProps>) {
  const { mutateAsync: updateAccount } = useMutationUpdateAccount(account._id);
  const [updateInProgress, setUpdateInProgress] = useState(false);
  const reportError = useReportError();

  const canChangeTaxSettings = hasAccountPermission(
    account,
    AccountPermission.ChangeTaxSettings,
  );

  const { watch, setValue } = useFormContext<Partial<Account>>();
  return (
    <AccountSubtypeSelector
      backgroundColor="white"
      currentValue={watch("accountSubType")}
      onSelected={async (accountSubType) => {
        try {
          setUpdateInProgress(true);
          setValue("accountSubType", accountSubType);
          await updateAccount({
            accountSubType,
          });
        } catch (error) {
          reportError(error);
        } finally {
          setUpdateInProgress(false);
        }
      }}
      isDisabled={!canChangeTaxSettings}
      isLoading={updateInProgress}
      {...props}
    />
  );
}
